import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { gsap } from '@/lib/gsap';
export function useHeroPinScroll(wrapperRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== wrapperRef) {
    t0 = () => {
      const wrapper = wrapperRef.current;
      if (!wrapper) {
        return;
      }
      const matchMedia = gsap.matchMedia();
      matchMedia.add({
        isDesktop: "(min-width: 992px)",
        isMobile: "(max-width: 991px)"
      }, context => {
        const {
          isMobile
        } = context.conditions as gsap.Conditions;
        if (isMobile) {
          return;
        }
        gsap.timeline({
          scrollTrigger: {
            toggleActions: "play pause pause reverse",
            trigger: wrapper,
            start: "+=1",
            end: "+=100%",
            pin: true,
            pinSpacing: false
          }
        });
      });
    };
    t1 = {
      scope: wrapperRef
    };
    $[0] = wrapperRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useGSAP(t0, t1);
}